import React, { useEffect, useState } from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import {
  createCategoryCost,
  updateCategoryCost,
} from "../../../apis/categoryCost";
import { missingPopup } from "../../../helperFunctions/missingFieldToast";
import { toastify } from "../../../helperFunctions/toastify";

export default function AddEditCategoryCost() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  const populateData = async () => {
    setName(state?.categoryCost?.name);
    setDescription(state?.categoryCost?.description);
  };

  const saveKol = async () => {
    if (!name) {
      missingPopup("Name");
    } else {
      if (!state?.categoryCost) {
        const response = await createCategoryCost({ name, description });
        if (response?.status !== "Fail") {
          toastify("Category Cost added successfully!", "success");
          navigate("/category-cost");
        } else {
          toastify(response?.message, "error");
        }
      } else {
        const response = await updateCategoryCost(state?.categoryCost?._id, {
          name,
          description,
        });
        if (response?.status !== "Fail") {
          toastify("Category Cost updated successfully!", "success");
          navigate("/category-cost");
        } else {
          toastify(response?.message, "error");
        }
      }
    }
  };

  useEffect(() => {
    if (state?.categoryCost) populateData();
  }, []);

  return (
    <React.Fragment>
      <div className="mainHeading px-4">
        <h1>
          <i
            className="fa fa-arrow-left cursor-pointer"
            onClick={() => navigate(-1)}
          ></i>
          {`${state?.categoryCost ? "Edit " : "New "}`}
          Category Cost
        </h1>
      </div>
      <div className="pb-4 px-4">
        <div className="content">
          <div className="addEdit pb-4">
            <div className="row">
              <div className="col-md-6">
                <Form.Group>
                  <Form.Label className="headings2">Name *</Form.Label>
                  <InputGroup className="mb-3">
                    <Form.Control
                      placeholder="Write..."
                      onChange={(e) => setName(e.target.value)}
                      value={name}
                    />
                  </InputGroup>
                </Form.Group>

                <Form.Group>
                  <Form.Label className="headings2">Description</Form.Label>
                  <InputGroup>
                    <Form.Control
                      as="textarea"
                      placeholder="Write..."
                      style={{ resize: "none" }}
                      onChange={(e) => setDescription(e.target.value)}
                      value={description}
                    />
                  </InputGroup>
                </Form.Group>
              </div>
            </div>
          </div>

          <div className="addEdit">
            <Button className="addItem" onClick={saveKol}>
              Save
            </Button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
